import {
    getAnimalUnit,
    getAverageIdleDaysRangeValues,
    getAverageLactationDaysValues,
    getAverageParturitionWeightRangeValues,
    getAverageSeparationWeightRangeValues,
    getCalculateResultsAfterSowCycles,
    getDaysForRepeatedInsemination,
    getFirstCycleIndex,
    getFirstTechnologyGroupStart,
    getHealthyPigletsPerLitterRangeValues,
    getIdleDays,
    getManageSubgroups,
    getMaxDelayForBirth,
    getMaximumIntervalBetweenSeparations,
    getParturitionIndexRangeValues,
    getPigletMortality,
    getResultsEventStartDate,
    getSeparatedPigletsPerLitterRangeValues,
    getTechnologyGroupWeeks,
    getTimeFromInseminationToPartuition,
    getTimeFromInseminationToPregnancy,
    getTimeOnBirthRoom,
    getTimeOnBirthRoomMommy,
    getTimeOnMatingRoom,
    getTimeOnSowsRoom,
    getValidationSettings,
} from "../SettingsUtils";

/**
 * funkcja zwracająca obiekt potrzebny niektórym funkcjom na wynikach
 * @returns {{technologyGroupWeeks: *, maxDelayForBirth: *, technologyGroupStart: (*|undefined), timeFromInseminationToParturition: *, animalUnit: any}}
 */
export function getUtilResults() {
    return {
        AnimalUnit: getAnimalUnit(),
        MaxDelayForBirth: getMaxDelayForBirth(),
        TimeFromInseminationToParturition:
            getTimeFromInseminationToPartuition(),
        TimeFromInseminationToPregnancy: getTimeFromInseminationToPregnancy(),
        TechnologyGroupWeeks: getTechnologyGroupWeeks(),
        TechnologyGroupStart: getFirstTechnologyGroupStart(),
        FirstCycleIndex: getFirstCycleIndex(),
        TimeOnBirthRoom: getTimeOnBirthRoom(),
        TimeOnBirthRoomMommy: getTimeOnBirthRoomMommy(),
        TimeBetweenInseminations: getDaysForRepeatedInsemination(),
        TimeOnMating: getTimeOnMatingRoom(),
        TimeOnSows: getTimeOnSowsRoom(),
        MaximumIntervalBetweenSeparations:
            getMaximumIntervalBetweenSeparations(),
        ParturitionIndexRange: getParturitionIndexRangeValues(),
        HealthyPigletsPerLitterRange: getHealthyPigletsPerLitterRangeValues(),
        SeparatedPigletsPerLitterRange:
            getSeparatedPigletsPerLitterRangeValues(),
        AverageParturitionWeightRange: getAverageParturitionWeightRangeValues(),
        AverageSeparationWeightRange: getAverageSeparationWeightRangeValues(),
        AverageIdleDaysRange: getAverageIdleDaysRangeValues(),
        AverageLactationDaysRange: getAverageLactationDaysValues(),
        ManageSubgroups: getManageSubgroups(),
        PigletsMortalityRange: getPigletMortality(),
        ResultsEventStartDate: getResultsEventStartDate(),
        CalculateResultsAfterSowCycles: getCalculateResultsAfterSowCycles(),
        IdleDays: getIdleDays(),
        validations: getValidationSettings(),
    };
}
